import Checkbox from './Checkbox';

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-checkbox@2.1.2@rc-checkbox/es/index.js
// module id = null
// module chunks = 